import {
  faReceipt,
  faChartLine,
  faFileLines,
  faBuildingUser,
  faCubesStacked,
  faListAlt,
  faMoneyBillTransfer,
  faBarsProgress,
  faBoxesPacking,
  faArrowRightFromBracket,
  faCog,
  faColumns,
  faCalculator,
  faMagnifyingGlassArrowRight,
  faCircleArrowRight,
  faCircleRight,
  faArrowRightLong,
  faArrowRight,
  faCartFlatbed,
  faTruckMoving,
  faRightToBracket,
  faTicketSimple,
  faCubes,
  faBoxesStacked,
  faUserCheck,
  faFileInvoice,
  faBookJournalWhills
} from "@fortawesome/free-solid-svg-icons"


export const GetLoginCredentialDb = (user, yearId) => {
  return { YearId: yearId, ClientCode: user.clientCode, LoginName: user.username, UserKey: user.userKey }
}
export const ENUM_INTCAL_OPTION = {
  WithGst: "WithGST",
  WithOutGst: "WithOutGST"
}
export const ENUM_USERSETING_PARAMS = {
  StartUp: "STARTUP",
}
export const ENUM_USERSETING_SETVALUE = {
  TextileCostFinance: "TEXTILE COST & FINANCIAL",
}
export const SALE_PUR_ENTRY_TYPE = {
  GrayCloth: "gray-cloth",
  Yarn: "yarn",
  Millgin: "millgin",
  General: "general"
}

export const ENUM_CATALOG_ENTRY_TYPE = {
  Inward: "Inwd",
  Outward: "Outwd"
}

export const INTEREST_CALBILL_TYPE = {
  Sale: "sale-bill",
  Purchase: "purchase-bill",
}
export const CHALLAN_TYPE = {
  Sale: "sale",
  Purchase: "purchase",
}
export const ENUM_ADM_KEY = "AdmWebApp"
export const ENUM_MAINDASHBOARD_DATAGROUP = {
  _00_OpeningStock: "00 as Yarn Stock",
  _01_YarnPurchase: "01 Yarn Purchase",
  _02_OtherExpense: "02 Other Purchase/Expenses",
  _11_Production: "11 Production",
  _21_GraySale: "21 Gray Sales",
  _21_OtherIncome: "21 Other Income",

}

export const ENUM_ENCRYPT_CODE = {
  receivable: "BuyQbvMAu@jYpIIf",
  payable: "hbtv1378hXt@c0nd",
  difference: "iplt@wDCp|HUjW!2@c0nd",
  purchase: "sfertq287857rtd",
  sale: "jhueki248e6tt",
  challan: "hm!urtrt[rhXt"
}

export const ENUM_ENTRY_TYPE = {
  RECEIVE: "Receive",
  PAYMENT: "Payment"
}
export const ENUM_APP_TYPE = {
  TEXTTILE: "TEXTTILE",
  GENERAL: "GENERAL"
}
export const ENUM_MOD_NAME = {
  SalesOrder: "Sale Order",// "GRAY CLOTH SALES ORDER",
  GraySaleMulti: "GRAY_SALE_MULTI",
  GrayProduction: "GRAY_PRODUCTION",
  YarnSale: "YarnSales",
  YarnSaleChallan: "YarnSaleChallan",
  YarnSaleCarton: "YarnSaleCarton",
  OtherSales: "OtherSales",
  general: "general",
  CostingDashboard: "APP_COSTING_DASHBOARD",
  GrayPurchaseInvoice: "GRAY_CLOTH_PURCHASE_INVOICE",
  YarnPurchaseChallan: "YarnPurchaseChallan",
  YarnPurchaseCarton: "YarnPurchaseCarton",
  MillginPurchaseInvoice: "MILLGINE_PURCHASE_INVOICE",
  GeneralPurchaseInvoice: "GENERAL_PURCHASE_INVOICE",
  GrayPurchaseTakaEntry: "Gray_Purchase_Taka_Entry",
  GrayPurchaseChallan: "GRAY_Purchase_Challan",
  YarnPurchaseInvoice: "YARN_PURCHASE_INVOICE",
  MasterItem: "MASTER_ITEM"
}
export const ENUM_MOD_PARAMETER = {
  CostingDashboard: {
    CalcWithGst: "CalcWithGst"
  },
  saleOrderEntry: {
    QtyOn: "Qty_On",
    Ochallan: "O_Challan",
    PackSize: "Pack_Size",
    CompName: "Comp_Name",
  },
  saleEntry: {
    TakaEntryMode: "Taka_Entry_Mode",
    // GridOrder: "GridOrder",
    // GridCut: "GridCut",
    // GridItemDet: "GridItem_Det",
    // Meter: "Meter",
    // Weight: "Weight",
    TakaGridDespLotNo: "TakaGrid_Desp_LotNo",

    Tds: "TDS",
    InwardTakaView: "InwardTakaView",
    AllowTaka: "AllowTaka",
    TcsCalc: "TCS_Calc",
    TakaGridPcsNo: "TakaGrid_PcsNo",

    // CartonDetail:"CARTON_DETAIL",
    AutoChallanEntry: "Auto_Challan_Entry",

  },
  generalSetting: {
    TcsRate: "TCS_Rate",
    TcsTurnOver: "TCS_Turnover",
    AppItemType: "AppItemType"
  },
  gridColumn: {
    GridOrder: "GridOrder",
    GridCut: "GridCut",
    GridItemDet: "GridItem_Det",
    Meter: "Meter",
    Weight: "Weight",
    GridCartonNo: "GridCartoonNo",
    GridMarko: "GridMarko",
    GridSubCat: "GridSubCat",
    GridColor: "GridColor",
    Discount: "Discount",
  },
  purchaseEntry: {
    TakaEntryMode: "Taka_Entry_Mode",
    TakaGridDespLotNo: "TakaGrid_Desp_LotNo",
    //Discount: "Discount",
    Tds: "TDS",
    InwardTakaView: "InwardTakaView",
    AllowTaka: "AllowTaka",
    VoucherEntry: "VoucharEntry",
    ChallanParty: "Challan_Party",
    ChallanDate: "Challan_Date",
    ChallanNo: "Challan_No",
    AutoChallanEntry: "Auto_Challan_Entry",
    Vat: "Vat",
    RoundUp: "RoundUp",
    TdsDetail: "TDSDetails",
  },
  productionEntry: {
    Avg_Weight_Kgs: "Avg_Weight_+/-_Kgs",
    TakaNo: "Taka_No",
    BeamNo: "BeamNo",
    Weight: "Weight",
    McNo: "MC_No",
    McNoPosition: "Mc_No_Position"
  },
  challanEntry: {
    CartonDetail: "CARTON_DETAIL",
    GridMtrLtr: "GridMtrLtr",
    DesignNo: "DesignNo",
    GridCartonNo: "GridCartoonNo",
    GridOrderNo: "GridOrderNo",
    GridGrossWgt: "GridGrossWgt",
    GridTareWgt: "GridTareWgt",
    GridLotNo: "Grid_LotNo",
    Color: "COLOR",
    ColorId: "COLOR_ID",
    SubCat: "SUB_CAT",
    DesignNo: "DesignNo"

  },
  inwardItemEntry: {
    CartonNo: "CartoonNo",
    Pcs: "Pcs",
    Cut: "Cut",
    Meter: "Meter",
    GWeight: "GWeight",
    TWeight: "TWeight",
    NWeight: "NWeight"
  },
  masterItem: {
    CostMeter: "COST_METER",
    DefWidth: "DEF_WIDTH",
    DefWarpWastage: "DEF_WARP_WASTAGE",
    DefWeftWastage: "DEF_WEFT_WASTAGE",
    DefPickConstant: "DEF_PICK_CONSTANT",
  }

}
export const funValidateNoInput = (value) => {

  if (/^\d*\.?\d*$/.test(value))
    return true
  else
    return false

}


export const getModVisiblity = (Parameter, data) => {

  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)

    if (filData && filData?.length > 0)
      return filData[0].Visible.toLowerCase() == 'true' ? true : false;
    else return false

  }
  else
    return false
}

export const getModMandatory = (Parameter, data) => {
  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)
    if (filData && filData?.length > 0)
      return filData[0].Mandatory.toLowerCase() == 'true' ? true : false;
    else
      return false
  }
  else
    return false
}

export const getModValue = (Parameter, data) => {
  if (data && data.length > 0) {
    const filData = data.filter((ele) => ele.Parameter == Parameter)
    if (filData && filData?.length > 0)
      return filData[0].Value
    else
      return ""
  }
  else
    return ""
}



const stateEnum = {
  outstandingPayable: "outstandingPayable",
  outstandingReceivable: "outstandingReceivable",
  company: "company",
  auth: "auth",
  ledger: "ledger",
  grayStock: "grayStock",
  dashboard: "dashboard",
  stock: "stock",
  invoice: "invoice",
  cerditDebitNote: "creditDebitNote",
  account: "account",
  salesOrder: "salesOrder",
  item: "item",
  receiveEntry: "receiveEntry",
  paymentEntry: "paymentEntry",
  production: "production",
  beamCard: "beamCard",
  jvEntry: "jvEntry",
  saleEntry: "saleEntry",
  purchaseEntry: "purchaseEntry",
  challanEntry: "challanEntry",
  monthExpEntry: "monthExpEntry",
  masterItemEntry: "masterItemEntry",
  catalogEntry: 'catalogEntry'


}

const outTypeEnum = {
  R: "R",
  G: "G",
  C: "C"
}
// const Item_type = {
//   GRAY: "GRAY",
//   SUITE: "SUITE",
// }
export const ENUM_ADVSEARCH_PARAM = {
  VouNo: "VouNo",
  Party: "Party",
  Item: "Item",
  Broker: "Broker",
  VouFromDate: "VouFromDate",
  VouToDate: "VouToDate",
  DueFromDate: "DueFromDate",
  DueToDate: "DueToDate",
  Status: "Status"

}
export const PAGE_API_FILTER = {
  CompCode: 0, BillType: '', TradeOF: ""
}
export const ENUM_STATUS = {
  Final: "Final",
  Pending: "Pending",
  Return: "Return",
  PartialReturn: "PartialReturn",
  PartialFinal: "PartialFinal",
  Paid: "Paid",
  PartPaid: "PartPaid",
  Close:"Close"
}

const ENUM_DASHBOARD_COLOR = {
  Party: "party",
  jobWork: "jobwork",
  Month: "month",
  Product: "product",
  Comb_Receivable: "Receivable",
  Comb_Payable: "Payable",
  Comb_Difference: "Difference",
  Comb_MonthYear: "Monthyear"
}

const linksUrl = {
  test: "/test",
  login: "/login",
  dashboard: {
    tradingDashboard: "/dashboard/trading-dashboard",
    masterDashboard: "/dashborad/costing-status-dashboard",
    itemWistCostDashboard: "/dashborad/itemcost-dashboard",
  },

  production: { grayProduction: "/grey-production" },
  resetPassword: "/user/reset-password",
  account: {
    createAccountMaster: "/account/create-account",
    accountMaster: "/account/account-master",

  },
  item: {
    itemMaster: "/item/item-master",
    createItemMaster: "/item/create-item"
  },
  production: {
    grayProduction: "/producttion/gray-production",
    createProdcutionEntry: "/production/create-entry",
    ProdcutionEntryMaster: "/production/production-master"
  },
  beamTransaction: {
    beamCardEntry: {
      createEntry: "/beam-transaction/create-entry",
      beamCardEntryMatser: "/beam-transaction/beamcard-master",
    }
  },
  modeSetting: {
    modSettingMaster: "/mod-settings",
    createmodSettingMaster: "/create-mod-settings"
  },
  monthExpense: {
    monthExpEntryMaster: "/monthly-expense",
    createEntry: "/monthly-expense/create-entry",
    monthClosingStock: "/monthly-closing-stock/create-entry",
    monthClosingStockMaster: "/monthly-closing-stock"
  },
  transaction: {
    creditDebitEntry: {
      invoicedatalist: "/transaction/credit-debit-note",
      creditdebitnote: "/transaction/credit-debit-note/create-entry",
      creditDebitReport: "/repots&view/credit-debit-details",
      trialBalanceReport: "/repots&view/trialbalance",
      profitLossReport: "/repots&view/profit-loss",
      balanceSheetReport: "/repots&view/balance-sheet"
    },
    receiveEntry: {
      receiveEntryMaster: "/transaction/receive-entry",
      createEntry: "/transaction/receive-entry/create-entry",

    },
    paymentEntry: {
      paymntEntryMaster: "/transaction/payment-entry",
      createEntry: "/transaction/payment-entry/create-entry"
    },
    salesOrderEntry: {
      createOrderEntry: "/sales-order/create-entry",
      orderEntryMaster: "/sales-order"
    },
    graySaleChallanEntry: {
      createGraySaleChallanEntry: "/gray-sale-challan/create-entry",
      graySaleChallanEntryMaster: "/gray-sale-challan"
    },
    journalVoucherEntry: {
      createJournalVoucherEntry: "/transaction/journal-voucher/create-entry",
      journalVoucherEntryMaster: "/transaction/journal-voucher"
    },
    SalesEntry: "/Sales/",
    PurchaseEntry: "/purchase/",
    ChallanEntry: "/challan/"

  },
  masterItemEntry: {
    createMasterItemEntry: "/masterItem/create-entry",
    masterItemEntryMaster: "/masterItem/list",
    yarnRateEntry:"/yarn-rate-mast"

  },
  catalogEntry: {
    inward: {
      createCatalogEntry: "/catalog-inward/create-entry",
      catalogEntryMaster: "/catalog-inward/list"
    },
    outward: {
      createCatalogEntry: "/outward/catalog/create-entry",
      catalogEntryMaster: "/outward/catalog/list",
      outwardList: "/outward-list"
    },
    accMast: {
      createAccEntry: "/catalog/Acc-entry",
      accEntryMaster: "/catalog/ACCount",
    },
     itemMast: {
      createProductEntry: "/catalog/Product-entry",
      productEntryMaster: "/catalog/Products",
    },
    stockList: "/catalog-stock-details",
    barcodePrint: "/catalog-barcodeprint"


  },
  simpletable: "/simpletable",

  partyPayTest: { get: "/outpaytest" },
  companies: "/",
  sales: {
    salesorder: "/salesorder-summary",
    ordersummary: "/order-summary",
  }, //added by shweta
  ledger: {
    get: "/ledger",
    getAccount: "/ledger/account",
  },
  multiCompLedger: {
    get: "/multi_ledger",
    getAccount: "/multi_ledger/account",
  },
  grayStock: {
    get: "/gray_stock",
    detail: "/gray_stock/detail",
  },

  stock: {
    get: "/stock",
    getFinishStock: "/finish-stock",
  },
  report: {
    invoice: {
      invoiceSummary: "/invoice/invoice-summary",
      rptInvoice: "/invoice/report",
      detail: "/invoice/detail",
      
    },
  },
  outstanding: {
    receivable: {
      partySummary: "/outstanding/receivable/party-summary",
      partyAgingSummary: "/outstanding/receivable/party-aging-summary",
      partyDetail: "/outstanding/receivable/party-detail",
    },
    payable: {
      partySummary: "/outstanding/payable/party-summary",
      partyAgingSummary: "/outstanding/payable/party-aging-summary",
      partyDetail: "/outstanding/payable/party-detail",
    },
    interestCalc: "/Interest-Calcultion/",
  },
  gstReport: {
    mainGst: "/master/mainGst",
    GstLedger: "/master/getGstLedger",
    GstPeriodicSummary: "/master/GstPeriodicSummary",
    GstRegister: "/master/GstRegister"
  },
  userCompMaping: {
    get: "/user-company-maping"

  },
}

const apiRoute = {
  company: "/company",
  companyAcYear: "/company/ac-year",
  setAcYearId: "/company/set-yearid",
  report: {
    invoice: {
      fetch: "/invoice",
      fetchInvoiceDetail: "/invoice/detail",
      getUnit:"/invoice/unit-list",
    },
    masterdata: {
      fetchAccount: "/invoice/account-master",
    },

  },
  eInvoice: {
    EwayBill: "/einvoice/getData",
    EwayBillGenerate: "/einvoice/generateEwaybill",
    einvoicedata: "/einvoice/einvoicedata",
    generateEinvoicebill: "/einvoice/generateEinvoicebill"
  },
  mainDashboard: {
    fetch: "/main-dashboard/fetch",
    fetchSummary: "/main-dashboard/fetch-summary",
    fetchPurSale: "/main-dashboard/sale-pursale",
    itemWiseCosting: {
      getItemCostingData: "/main-dashboard/fabyarn-data"
    },
  },
  resetPassword: "/user/reset-password",
  item: {
    fetch: "/item/fetch-item",
    deleteitem: "/item/item-delete",
    masterData: "/item/master-data",
    fetchGstType: "/item/gst-type",
    addUpdate: "/item/add-update",
    checkItemCode: "/item/check-item-code",
    getItemImage: "/item/item-image"
  },
  account: {
    fetch: "/account/fetch-account",
    deleteAccount: "/account/account-delete",
    masterTypeProcess: "/account/master-type-process",
    masterPartyTradeState: "/account/master-party-trade-state",
    checkacid: "/account/check-acid",
    add: "/account/add",
    fetchAcByType: "/account/account-by-type",
    addBroker: '/account/broker/add',
    fetchBroker: '/account/broker/fetch',
    addTransport: '/account/transport/add',
    fetchTransport: '/account/transport/fetch',
    addDelivery: '/account/delivery/add',
    fetchDelivery: '/account/delivery/fetch',
    verifyGstDetail: '/account/gst-verify',
    generateAcID: '/account/gen-acid'
  },
  modeSetting: {
    masterModList: "/mod-setting/mod-list",
    fetchModData: "/mod-setting/mod-data",
    add: "/mod-setting/add",
    update: "/mod-setting/update",
    getAppType: "/mod-setting/app-type",
    getModSetting: "/mod-setting/get-setting",
    getMultiModSetting: "/mod-setting/get-multi-setting"
  },
  userCompMaping: {
    masterData: "/usercomp-maping/master-data",
    addUpdate: "/usercomp-maping/add-update",
    getUserMaping: "/usercomp-maping/user-maping"
  },
  salesorder: {
    fetch: "/salesorder",
    fetchPartyMasterData: "/salesorder/party-master",
    fetchMasterData: "/salesorder/master-data",
    fetchGenfasOrder: "/salesorder/genfas-order"
  },
  monthExpense: {
    fetchMasterData: "/monthexp/master-data",
    add_update: "/monthexp/add-update",
    fetchEntry: "/monthexp/fetch",
    fetchEntryDetail: "/monthexp/detail",
    deleteEntry: "/monthexp/delete-entry",
    fetchAcc: "/monthexp/acc",
    mcsAddupdate: "/monthexp/mcs-addup",
    mcsFetchEntry: "/monthexp/mcs-fetch",
    mcsDeleteEntry: "/monthexp/mcs-delete"
  },

  transaction: {
    creditdebitnote: {
      add: "/credit-debit-note/add",
      update: "/credit-debit-note/update",
      fetchInvoice: "/credit-debit-note/invoice",
      fetchInvoiceDetail: "/credit-debit-note/detail",
      fetchMasterData: "/credit-debit-note/master-data",
      generateVouNo: "/credit-debit-note/generate-vouno",
      deleteNote: "/credit-debit-note/delete-note",
      fetchBillNo: "/credit-debit-note/fetch-billno",
      getCreditDebitData: "/credit-debit-note/crdr-data",
      getTrialBalanceData: "/credit-debit-note/tb-data",
      getProfitLossData: "/credit-debit-note/pnl-data",
      getBalanceSheetData: "/credit-debit-note/bs-data"
    },
    receiveEntry: {
      fetchMasterData: "/receive-entry/master-data",
      add_update: "/receive-entry/add-update",
      fetch: "/receive-entry/fetch-entry",
      fetchEntryDetail: "/receive-entry/detail",
      deleteEntry: "/receive-entry/delete-entry",
      getBill: "/receive-entry/get-bills",
    },
    paymentEntry: {
      fetchMasterData: "/payment-entry/master-data",
      add_update: "/payment-entry/add-update",
      fetch: "/payment-entry/fetch-entry",
      fetchEntryDetail: "/payment-entry/detail",
      deleteEntry: "/payment-entry/delete-entry",
      getBill: "/payment-entry/get-bills",
    },
    salesOrderEntry: {
      entryMasterData: "/salesorder/entry-master-data",
      add_update: "/salesorder/add-update",
      fetchOrder: "/salesorder/fetch",
      fetchOrderDetail: "/salesorder/fetch-detail",
      generateOrderNo: "/salesorder/generate-ordno",
      deleteEntry: "/salesorder/delete-entry",
      getOrderShow:"/salesorder/order-show",
      getOrderDetail:"/salesorder/order-detail"
    },
    SaleEntry: {
      entryMasterData: "/sale-entry/entry-master-data",
      add_update: "/sale-entry/add-update",
      fetch: "/sale-entry/fetch-entry",
      fetchEntryDetail: "/sale-entry/entry-detail",//
      fetchGrayStockDetail: "/sale-entry/gray-stock-detail",
      generateVoucherNo: "/sale-entry/generate-vouno",
      deleteEntry: "/sale-entry/delete-entry",
      fetchGrayItems: "/sale-entry/fetch-gray-items",
      fetchEntryStock: "/sale-entry/entry-stock",
      fetchTakaListTocheck: "/sale-entry/takano-list",
      fetchOrderList: "/sale-entry/order-list",
      fetchGroupCompList: "/sale-entry/group-comp-list",
      updateEwayBill: "/sale-entry/update-ewaybill",
      fetchTurnOver: "/sale-entry/chk-turnover",
      challanPrint: "/sale-entry/challn-report",
      fetchLastBillData: "/sale-entry/last-bill"
    },
    PurchaseEntry: {
      entryMasterData: "/purchase-entry/entry-master-data",
      add_update: "/purchase-entry/add-update",
      fetch: "/purchase-entry/fetch-entry",
      fetchEntryDetail: "/purchase-entry/entry-detail",//
      generateVoucherNo: "/purchase-entry/generate-vouno",
      deleteEntry: "/purchase-entry/delete-entry",
      challanData: "/purchase-entry/challan-data",
      fetchEntryStock: "/purchase-entry/entry-stock",
    },
    journalVoucherEntry: {
      entryMasterData: "/journal-voucher/entry-master-data",
      add_update: "/journal-voucher/add-update",
      fetchEntry: "/journal-voucher/fetch",
      fetchEntryDetail: "/journal-voucher/fetch-detail",
      generateJvVouNo: "/journal-voucher/generate-jvvouno",
      deleteEntry: "/journal-voucher/delete-entry"
    },
    challanEntry: {
      fetchEntryStock: "/challan-entry/entry-stock",
      generateVoucherNo: "/challan-entry/generate-vouno",
      add_update: "/challan-entry/add-update",
      fetch: "/challan-entry/fetch-entry",
      deleteEntry: "/challan-entry/delete-entry",
      fetchEntryDetail: "/challan-entry/entry-detail"
    }
  },
  outstanding: {
    partySummary: "/outstanding/summary",
    partyDetail: "/outstanding/detail",
    partyAgingSummary: "/outstanding/aging-summary",
    partyInfo: "/outstanding/party/info",
    partyBrokerInfo: "/outstanding/party/info-broker",
    partyBills: "/outstanding/interest-calc/bills-info",
    masterData: "/outstanding/master-data"
  },
  ledger: {
    fetch: "/ledger",
    account: {
      fetch: "/ledger/account",
    },
    accountType: "/ledger/account-type",
    multiAccount: {
      fetch: "/ledger/multi-account-ledger"
    },
    multiLedger: {
      fetch: "/ledger/multi-ledger"
    }
  },
  grayStock: {
    fetch: "/gray-stock",
    fetchItemMaster: "/gray-stock/item-master",
  },
  masterItemEntry: {
    entryMasterData: "/masteritem-entry/entry-master-data",
    add_update: "/masteritem-entry/add-update",
    fetch: "/masteritem-entry/fetch-entry",
    fetchEntryDetail: "/masteritem-entry/entry-detail",
    deleteEntry: "/masteritem-entry/entry-delete",
    getYarnCost: "/masteritem-entry/yarn-cost",
    updateItemRate: "/masteritem-entry/update-itemrate",
    fetchYarnRateList: "/masteritem-entry/yarn-rate",
  },
  catalogEntry: {
    entryMasterData: "/catalog/entry-master-data",
    add_update: "/catalog/add-update",
    fetch: "/catalog/fetch-entry",
    fetchEntryDetail: "/catalog/entry-detail",
    deleteEntry: "/catalog/entry-delete",
    generateVoucherNo: "/catalog/generate-vouno",
    getItemList: "/catalog/item-list",
    getItemStock: "/catalog/item-stock",
    getPersonList: "/catalog/person-list"

  },
  stock: {
    fetch: "/stock",
    fetchItemMaster: "/stock/item-master",
    fetchFinishStock: "/stock/finish-stock"
  },
  dashboard: {
    getTradingData: "/dashboard/trading",
    getPurchaseData: "/dashboard/purchase",
    getMultiYearPurchaseData: "/dashboard/multi-purchase",
    getMultiYearSaleData: "/dashboard/multi-sale",
    getMultiYearTradingData: "/dashboard/multi-trading",
    getSaleData: "/dashboard/sale",
    getOutstandingData: "/dashboard/outstanding",
  },

  gstReport: {
    getGstLedger: "/gstreport/getGstLedger",
    GstPeriodicSummary: "/gstreport/GstPeriodicSummary",
    GstRegister: "/gstreport/GSTRegisterSummary"
  },
  production: {
    greyProduction: "/production/gray",
    entryMasterData: "/production/entry-master-data",
    add_update: "/production/add-update",
    checkTakaNo: "/production/check-takano",
    checkChalNo: "/production/check-chalno",
    fetch: "/production/fetch-entry",
    fetchEntryDetail: "/production/entry-detail",
    deleteEntry: "/production/entry-delete",
    getMachineData: "/production/mcno-data",
    getMaxTakaNo: "/production/max-takano",
    genNewChalNo: "/production/gen-chalno",

  },

  beamTransaction: {
    beamCardEntry: {
      entryMasterData: "/beam-card/master-data",
      fetch: "/beam-card/fetch-entry",
      fetchEntryDetail: "/beam-card/entry-detail",
      deleteEntry: "/beam-card/entry-delete",
      add_update: "/beam-card/add-update",
    }

  }

}

const sideNavLinks = [
  // {
  //   name: "Test",
  //   key: "Companies",
  //   icon: faBuildingUser,
  //   url: linksUrl.test,
  // },

  {
    name: "Company Master",
    key: "Companies",
    icon: faBuildingUser,
    url: linksUrl.companies,
  },

  {
    key: "Dashboard",
    name: "Dashboard",
    icon: faChartLine,
    sub: [
      {
        name: "Trading",
        key: "Dashboard",
        icon: faArrowRightFromBracket,
        url: linksUrl.dashboard.tradingDashboard,
      },
      {
        name: "Costing & Financial Status",
        key: "MasterDashboard",
        icon: faArrowRightFromBracket,
        url: linksUrl.dashboard.masterDashboard,
      },
      {
        name: "Gray Item Costing View",
        key: "GrayItemCostingDashboard",
        icon: faArrowRightFromBracket,
        url: linksUrl.dashboard.itemWistCostDashboard,
      },

    ]
  },
  {
    name: "Master",
    key: "Master",
    icon: faBarsProgress,
    sub: [
      {
        name: "Accounts",
        key: "Accounts",
        icon: faRightToBracket,
        sub: [
          {
            name: "Account Master",
            key: "AccountMaster",
            icon: faArrowRight,
            url: linksUrl.account.accountMaster,
          },
          {
            name: "Account Master",
            key: "CatalogAccountEntry",
            icon: faArrowRight,
            url: linksUrl.catalogEntry.accMast.accEntryMaster,
          },

        ]
      },
      {
        name: "Item / Product",
        key: "Products",
        icon: faRightToBracket,
        sub: [
          {
            name: "Item Master",
            key: "ItemMaster",
            icon: faArrowRight,
            url: linksUrl.item.itemMaster,
          },
          {
            name: "Product Master",
            key: "CatalogProductEntry",
            icon: faArrowRight,
            url: linksUrl.catalogEntry.itemMast.productEntryMaster,
          },
          {
            name: "Master Item",
            key: "MasterItemEntry",
            icon: faArrowRight,
            url: linksUrl.masterItemEntry.masterItemEntryMaster,
          },
          {
            name: "Yarn and Fabric Cost Rate",
            key: "YarnAndFabricCostRate",
            icon: faArrowRight,
            url: linksUrl.masterItemEntry.yarnRateEntry,
          },

        ]
      },
    ]
  },
  {
    name: "Purchase",
    key: "PurchaseEntryMaster",
    icon: faCartFlatbed,
    sub: [
      {
        name: "Yarn Purchase",
        key: "YarnPurchase",
        icon: faCubes,
        sub: [
          {
            name: "Yarn Purchase Invoice",
            key: "YarnPurchaseEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.PurchaseEntry + SALE_PUR_ENTRY_TYPE.Yarn,
          },
          {
            name: "Yarn Purchase Challan",
            key: "YarnPurchaseChallanEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.ChallanEntry + CHALLAN_TYPE.Purchase + "/" + SALE_PUR_ENTRY_TYPE.Yarn,
          },

        ]
      },
      {
        name: "Gray Cloth Purchase",
        key: "GrayPurchase",
        icon: faBoxesStacked,
        sub: [
          {
            name: "Gray Cloth Purchase Invoice",
            key: "GrayPurchaseEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.PurchaseEntry + SALE_PUR_ENTRY_TYPE.GrayCloth,
          },
          {
            name: "Gray Cloth Purchase Challan ",
            key: "GrayPurchaseChallanEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.ChallanEntry + CHALLAN_TYPE.Purchase + "/" + SALE_PUR_ENTRY_TYPE.GrayCloth,
          },

        ]
      },
      {
        name: "Millgin Goods Purchase",
        key: "MillginPurchaseEntry",
        icon: faArrowRightFromBracket,
        url: linksUrl.transaction.PurchaseEntry + SALE_PUR_ENTRY_TYPE.Millgin,
      },
      {
        name: "General Purchase",
        key: "GeneralPurchaseEntry",
        icon: faArrowRightFromBracket,
        url: linksUrl.transaction.PurchaseEntry + SALE_PUR_ENTRY_TYPE.General,
      },

    ]
  },
  {
    name: "Sales",
    key: "SaleEntryMaster",
    icon: faTruckMoving,
    sub: [
      {
        name: "Yarn Sales",
        key: "YarnSales",
        icon: faCubes,
        sub: [
          {
            name: "Yarn Sales Invoice",
            key: "YarnSaleEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.SalesEntry + SALE_PUR_ENTRY_TYPE.Yarn,
          },
          {
            name: "Yarn Sales Challan",
            key: "YarnSaleChallanEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.ChallanEntry + CHALLAN_TYPE.Sale + "/" + SALE_PUR_ENTRY_TYPE.Yarn,
          },


        ]
      },
      {
        name: "Gray Cloth Sales",
        key: "GraySales",
        icon: faBoxesStacked,
        sub: [
          {
            name: "Gray Cloth Sales Invoice",
            key: "GraySaleChallanEntry",
            icon: faArrowRight,
            url: linksUrl.transaction.SalesEntry + SALE_PUR_ENTRY_TYPE.GrayCloth,
          },

          {
            name: "Gray Cloth Sales Order",
            key: "SalesOrderMaster",
            icon: faArrowRight,
            url: linksUrl.transaction.salesOrderEntry.orderEntryMaster,
          },
          // {
          //   name: "Gray Challan ",
          //   key: "GrayPurchaseChallan",
          //   icon: faArrowRightFromBracket,
          //   url: linksUrl.transaction.ChallanEntry + CHALLAN_TYPE.Sale + "/" + SALE_PUR_ENTRY_TYPE.GrayCloth,
          // },

        ]
      },
      {
        name: "Sale Order",
        key: "GenFasSaleOrderEntry",
        icon: faArrowRight,
        url: linksUrl.transaction.salesOrderEntry.orderEntryMaster,
      },
      // {
      //   name: "Millgin Sales",
      //   key: "MillginSaleEntry",
      //   icon: faArrowRightFromBracket,
      //   url: linksUrl.transaction.SalesEntry + SALE_PUR_ENTRY_TYPE.Millgin,
      // },
      // {
      //   name: "General Sales",
      //   key: "GeneralSaleEntry",
      //   icon: faArrowRightFromBracket,
      //   url: linksUrl.transaction.SalesEntry + SALE_PUR_ENTRY_TYPE.General,
      // },

    ]
  },
  {
    name: "Accounts",
    key: "Transaction",
    icon: faMoneyBillTransfer,
    sub: [

      {
        name: "Receive Transaction",
        key: "ReceiveEntryMaster",
        icon: faArrowRightFromBracket,
        url: linksUrl.transaction.receiveEntry.receiveEntryMaster,
      },
      {
        name: "Payment Transaction",
        key: "PaymentEntryMaster",
        icon: faArrowRightFromBracket,
        url: linksUrl.transaction.paymentEntry.paymntEntryMaster,
      },
      {
        name: "Debit /Credit Note",
        key: "CreditDebitNote",
        icon: faArrowRightFromBracket,
        // icon: faFileInvoice,
        url: linksUrl.transaction.creditDebitEntry.invoicedatalist,
      },

      {
        name: "Journal Voucher J/V",
        key: "JournalVoucherEntryMaster",
        icon: faArrowRightFromBracket,
        url: linksUrl.transaction.journalVoucherEntry.journalVoucherEntryMaster,
      },


    ],
  },
  {
    name: "Product Catalog",
    key: "ProductCatalog",
    icon: faBookJournalWhills,
    sub: [{
      name: "Catalog Inward",
      key: "CatalogInwardEntry",
      icon: faArrowRightFromBracket,
      url: linksUrl.catalogEntry.inward.catalogEntryMaster + "/" + ENUM_CATALOG_ENTRY_TYPE.Inward,
    },
    {
      name: "Catalog Outward",
      key: "CatalogOutwardEntry",
      icon: faArrowRightFromBracket,
      url: linksUrl.catalogEntry.outward.catalogEntryMaster + "/" + ENUM_CATALOG_ENTRY_TYPE.Outward,
    },
    {
      name: "Outward List",
      key: "ProductCatalogOutwardReport",
      icon: faArrowRightFromBracket,
      url: linksUrl.catalogEntry.outward.outwardList
    },
    {
      name: "Stock Detail",
      key: "ProductCatalogStockReport",
      icon: faArrowRightFromBracket,
      url: linksUrl.catalogEntry.stockList
    },
    {
      name: "Barcode Print",
      key: "ProductCatalogBarcodePrint",
      icon: faArrowRightFromBracket,
      url: linksUrl.catalogEntry.barcodePrint
    }
    ],


  },
  {
    key: "OtherTransaction",
    name: "Other Transaction",
    icon: faReceipt,
    sub: [
      {
        name: "Month Exp",
        key: "MonthExpenseEntry",
        icon: faArrowRightFromBracket,
        url: linksUrl.monthExpense.monthExpEntryMaster,
      },
      {
        name: "Monthly Closing Stock",
        key: "MonthlyClosingStockEntry",
        icon: faArrowRightFromBracket,
        url: linksUrl.monthExpense.monthClosingStock,
      },

    ]
  },
  {
    name: "Production",
    key: "Production",
    icon: faBoxesPacking,
    sub: [{
      name: "Gray Production",
      key: "GrayProduction",
      icon: faArrowRightFromBracket,
      url: linksUrl.production.grayProduction,
    },
    {
      name: "Gray Production Entry",
      key: "GrayProductionEntry",
      icon: faArrowRightFromBracket,
      url: linksUrl.production.ProdcutionEntryMaster,
    },
    ],


  },
  {
    name: "Reports & View",
    key: "ReportAndView",
    icon: faListAlt,
    sub: [
      {
        key: "AccountReports",
        name: "Account Reports",
        icon: faFileInvoice,
        sub: [
          {
            name: "Debit/Credit Note ",
            key: "CreditDebitNoteReport",
            icon: faArrowRightFromBracket,
            url: linksUrl.transaction.creditDebitEntry.creditDebitReport,
          },

        ]
      },
      {
        key: "outstanding",
        name: "Outstanding",
        icon: faFileLines,
        sub: [
          {
            name: "Receivable",
            key: "OutRPartySummary",
            icon: faArrowRight,
            url: linksUrl.outstanding.receivable.partySummary,
          },
          {
            name: "Payable",
            key: "OutPPartySummary",
            icon: faArrowRight,
            url: linksUrl.outstanding.payable.partySummary,
          },

        ],
      },
      {

        name: "Interest Calculation",
        key: "InterestCalculation",// "InterestCalculation",
        icon: faCalculator,
        sub: [
          {
            name: "Sale Bill",
            key: "IntCalSaleBill", // "IntCalSaleBill",
            icon: faArrowRight,
            url: linksUrl.outstanding.interestCalc + INTEREST_CALBILL_TYPE.Sale,
          },
          {
            name: "Purchase Bill",
            key: "IntCalPurchaseBill", // "IntCalSaleBill",
            icon: faArrowRight,
            url: linksUrl.outstanding.interestCalc + INTEREST_CALBILL_TYPE.Purchase,
          },

        ],

      },
      {
        key: "FinalReports",
        name: "Final Reports",
        icon: faFileLines,
        sub: [

          {
            name: "Trial Balance",
            key: "TrialBalanceReport",
            icon: faArrowRightFromBracket,
            url: linksUrl.transaction.creditDebitEntry.trialBalanceReport,
          },
          {
            name: "Profit & Loss",
            key: "ProfitLossReport",
            icon: faArrowRightFromBracket,
            url: linksUrl.transaction.creditDebitEntry.profitLossReport,
          },
          {
            name: "Balance Sheet",
            key: "ProfitLossReport",
            icon: faArrowRightFromBracket,
            url: linksUrl.transaction.creditDebitEntry.balanceSheetReport,
          },
        ]
      },

      {
        name: "Stock",
        key: "Stock",
        icon: faArrowRightFromBracket,
        // icon: faCubesStacked,
        url: linksUrl.stock.get,
      },
      {
        name: "Finish Product Stock",
        key: "FinishProductStock",
        icon: faArrowRightFromBracket,
        // icon: faCubesStacked,
        url: linksUrl.stock.getFinishStock,
      },
      {
        name: "Ledger",
        key: "Ledger",
        icon: faArrowRightFromBracket,
        // icon: faReceipt,
        url: linksUrl.ledger.get,
      },
      {
        name: "Gray Stock",
        key: "GrayStock",
        icon: faArrowRightFromBracket,
        // icon: faCubesStacked,
        url: linksUrl.grayStock.get,
      },
      {
        name: "Order Summary",
        key: "SalesOrderSummary",
        icon: faArrowRightFromBracket,
        url: linksUrl.sales.salesorder,
      },
      {
        name: "Order Summary",
        key: "GenFasSaleOrderSummary",
        icon: faArrowRightFromBracket,
        url: linksUrl.sales.ordersummary,
      },
      {
        name: "Sales/Purchase Data",
        key: "SalesData",
        icon: faArrowRightFromBracket,
        url: linksUrl.report.invoice.invoiceSummary,
      },

      {
        name: "GST Report",
        key: "GstReport",
        icon: faArrowRightFromBracket,
        url: linksUrl.gstReport.mainGst,
      },

    ],
  },
  {
    name: "Software Settings",
    key: "SoftwareSettings",
    icon: faCog,
    sub: [
      {
        name: "User",
        key: "UserSettingWebApp",
        icon: faUserCheck,
        sub: [
          {
            name: "Company Mapping",
            key: "UserCompanyMapingWebApp",
            icon: faArrowRightFromBracket,
            url: linksUrl.userCompMaping.get,
          },
        ],
      },
      {
        name: "Mod Settings",
        key: "CreateModSetting",
        icon: faArrowRightFromBracket,
        url: linksUrl.modeSetting.createmodSettingMaster,
      }]

  },

]

const ENUM_INPUT_TYPE = {
  text: "text",
  number: "number",
  select: "select",
  email: "email",
  date: "date",
  multiline: "multiline",
  autocomplete: "autocomplete"
}

const ENUM_ACTYPE = {
  Transapoter: "Transapoter",
  Broker: "Broker",
  Delivery: "Delivery Party"
}

const ENUM_BILL_TYPE = {
  FULL: "FULL",
  PART: "PART",
}

const ENUM_BILL_TYPE_LIST = [
  { value: "--Select-", key: "" },
  { value: "FULL", key: "FULL" },
  { value: "PART PAYMENT", key: "PART" }
]
export { linksUrl, stateEnum, outTypeEnum, apiRoute, sideNavLinks, ENUM_DASHBOARD_COLOR, ENUM_INPUT_TYPE, ENUM_ACTYPE, ENUM_BILL_TYPE, ENUM_BILL_TYPE_LIST }
